import axios from 'axios';
import { NotificationManager } from 'react-notifications';
import configFile from "config.json";
import { Auth } from 'aws-amplify';

export const fetchMajorGroups = async () => {
  const {
    accessToken: { jwtToken },
  } = await Auth.currentSession();
  try {
    const { data: response } = await axios.post(`${configFile.PROD_SERVER_URL}/menu2/option/listMajorGroups`, {}, {
      headers: {
        Authorization: `Bearer ${jwtToken}`,
      },
    });
    return response
  } catch (err) {
    NotificationManager.error(
      err?.response?.data?.errorMessage,
      "Error",
      5000
    );
    console.log(err);
  }
}

export const fetchTags = async () => {
  try {
    const result = await axios.post(`${configFile.PROD_SERVER_URL}/tag/getAllTags`);
    const rows = result?.data?.data || [];
    if (Array.isArray(rows) && rows.length) {
      return rows
    }
    return []
  } catch (error) {
    console.log(error);
  }
};

export const copyToClipBoard = async (copyMe) => {
  try {
    await navigator.clipboard.writeText(copyMe);
    NotificationManager.success('Copied');
    // setCopySuccess('Copied!');
  } catch (err) {
    // setCopySuccess('Failed to copy!');
  }
};
